module.exports = __webpack_public_path__ + "img/logo_trace2.2aeabad1.png";